import './Modal.scss';

const Modal = ({ width, children }) => {
  return (
    <div className="modal">
      <div className="modal-body" style={{ width: `${width}px` }}>
        {children}
      </div>
    </div>
  );
};

export default Modal;
